var map = {
	"./bio.png": "55a1",
	"./download.png": "0a37",
	"./github.png": "8d46",
	"./help.png": "c402",
	"./link.png": "d744",
	"./logo.png": "6a77",
	"./mail.png": "f1bf",
	"./open.png": "1e0b",
	"./opensource.png": "b212",
	"./photos.png": "a738",
	"./resume.png": "8240",
	"./send.png": "c166",
	"./sidebar-image.png": "4c36",
	"./speakers.png": "7d0a",
	"./warning.png": "28f9",
	"./webos.png": "6bf5",
	"./win95.png": "5001"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aa3b";